import Dashes = require("./linedash");

export =
    [
        {
            "stroke": {
                "color": "yellow",
                "width": 2,
                "lineDash": Dashes.dot
            }

        }
    ];